import { SupplierPublicBrand } from '../../types';

export const MOCK_SUPPLIER_BRANDS: SupplierPublicBrand[] = [
  {
    supplierId: 'sup-tongrentang',
    publicSlug: 'tongrentang',
    publicBrandName: 'Tongrentang',
    publicLogo: 'https://images.unsplash.com/photo-1542884748-2b87b36c6b90?w=200',
    publicBanner: 'https://images.unsplash.com/photo-1546069901-eacef0df6022?w=1600',
    publicDescription:
      'Tongrentang has been producing premium-grade traditional Chinese herbal medicines since 1669. Every batch is sourced from heritage farms and finished under pharmacopoeia-aligned QC.',
  },
  {
    supplierId: 'sup-beijing-trt',
    publicSlug: 'beijing-trt',
    publicBrandName: 'Beijing TRT',
    publicLogo: 'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=200',
    publicBanner: 'https://images.unsplash.com/photo-1582719188393-bb71ca45dbb9?w=1600',
    publicDescription:
      'Beijing TRT specialises in heat-clearing and tonifying formulae, with herbs cultivated across the Hebei and Shandong corridors. AU/NZ TGA-listed manufacturing.',
  },
  {
    supplierId: 'sup-tasly',
    publicSlug: 'tasly',
    publicBrandName: 'Tasly',
    publicLogo: 'https://images.unsplash.com/photo-1559757175-08c2c8c8a2a4?w=200',
    publicBanner: 'https://images.unsplash.com/photo-1505751172876-fa1923c5c528?w=1600',
    publicDescription:
      'Tasly modernises classic TCM with GMP-grade extraction and standardised potency assays — well suited to clinic dispensaries running tight inventory.',
  },
  {
    supplierId: 'sup-yunnan-baiyao',
    publicSlug: 'yunnan-baiyao',
    publicBrandName: 'Yunnan Baiyao',
    publicLogo: 'https://images.unsplash.com/photo-1607619056574-7b8d3ee536b2?w=200',
    publicBanner: 'https://images.unsplash.com/photo-1518495973542-4542c06a5843?w=1600',
    publicDescription:
      'Yunnan Baiyao is renowned for its proprietary haemostatic formula. Their dried-herb division supplies practitioners across Asia-Pacific.',
  },
  {
    supplierId: 'sup-generic',
    publicSlug: 'generic-herbs',
    publicBrandName: 'Generic',
    publicLogo: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=200',
    publicDescription:
      'Aggregated supply from a network of audited small-batch Chinese herb cooperatives.',
  },
  {
    supplierId: 'sup-vmall-academy',
    publicSlug: 'vmall-academy',
    publicBrandName: 'VMall Academy',
    publicLogo: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=200',
    publicBanner: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=1600',
    publicDescription:
      'Continuing education partner for TCM practitioners — online courses, certification programmes, and clinic-day workshops.',
  },
];

const brandToSupplier: Record<string, string> = {
  Tongrentang: 'sup-tongrentang',
  'Beijing TRT': 'sup-beijing-trt',
  Tasly: 'sup-tasly',
  'Yunnan Baiyao': 'sup-yunnan-baiyao',
  Generic: 'sup-generic',
};

export const supplierIdForBrand = (brand?: string): string | undefined =>
  brand ? brandToSupplier[brand] : undefined;

export const supplierBriefFor = (brand?: string) => {
  const id = supplierIdForBrand(brand);
  if (!id) return undefined;
  const s = MOCK_SUPPLIER_BRANDS.find((b) => b.supplierId === id);
  if (!s) return undefined;
  return {
    supplierId: s.supplierId,
    publicSlug: s.publicSlug,
    publicBrandName: s.publicBrandName,
    publicLogo: s.publicLogo,
  };
};
